export const MissingInputError = {message: 'Nicht alle notwendigen Informationen wurden ausgefüllt.'};
export const DetailMissingInputError = (field, t) => ({
  message: t('clientError.missingError') + (field ? ` (${field})` : ''),
});



// WEBPACK FOOTER //
// ./src/errors/InputErrors.js